import React from 'react';
import { EscalatedIssue } from '../callCenterDashboardTypes';
import styles from './EscalatedIssuesCard.module.css';

interface EscalatedIssuesCardProps {
  issues: EscalatedIssue[];
}

export const EscalatedIssuesCard: React.FC<EscalatedIssuesCardProps> = ({ issues }) => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>
          <span className={styles.headerIcon}>⚠️</span> Escalated Issues
        </h3>
        <span className={styles.criticalBadge}>{issues.length} Critical</span>
      </div>
      <div className={styles.list}>
        {issues.map((issue) => (
          <div key={issue.id} className={`${styles.issue} ${styles[issue.variant]}`}>
            <div className={styles.issueHeader}>
              <span className={styles.ticketId}>{issue.ticketId}</span>
              <span className={styles.dash}>—</span>
              <span className={styles.issueTitle}>{issue.title}</span>
            </div>
            <p className={styles.description}>{issue.description}</p>
            <p className={styles.meta}>{issue.meta}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
